import { BrowserRouter, Routes, Route } from "react-router-dom";
import SpaceOrderCalendar from "./component/SpaceOrderCalendar";
import ScheduleTimeline from "./component/ScheduleTimeline";
import React from "react";
import "./App.css";

function App() {
  // basename lets the same bundle serve from the domain root (Vercel) or from a
  // sub-path: the demo container is mounted at /matrix on the demo host, so it
  // needs no extra DNS record and no second-level TLS cert. CRA bakes PUBLIC_URL
  // at build time and leaves it empty by default, so existing root-hosted builds
  // are unaffected.
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL || undefined}>
      <Routes>
        <Route path="/time/:token/" element={<SpaceOrderCalendar />} />
        <Route path="/3DSpace/:token/" element={<ScheduleTimeline />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
